<div class="viewport-1" [style.background-image]="'url(' + taskBackgroundImage + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="totalTaskPoints"></task-bar>

  <div class="task-screen-element fill-in-blank-container"
    [style.background-image]="' ' + taskContainerColor + ' '"
    [class]="(animationComplete) ? 'taskShow' : 'taskHide'">
    <button class="replayVideo-no-timerbar" (click)="replayVideo()" [disabled]="disableAVButtons"></button>
    <div class="word-to-verify">
      <!-- tiles that spell the incomplete word will go in here
      Probably use ngFor to loop over letters in the target word-->
      <button class="speaker" (click)="playWordAudio()" [disabled]="disableAVButtons"></button>
      <div class="diagnostic-target-row">
        @for (letter of targetWord; track $index) {
          <div class="diagnostic-target-block" [class.first-target-block-left-fill]="showTargetSilentE"
            >
            <div class="diagnostic-target-text font-30">
              {{letter}}
            </div>
          </div>
        }
      </div>
    </div>
    <!-- response options on tiles will go in here (will need to separate into two sets for the different rows)
    Probably ngFor looping through the response options-->
    <div class="response-row">
      @for (response of responseOptions1; track $index) {
        <div class="button-div">
          <button class="font-30" [class]="(disableResponseButtons) ? 'response-block-grayed' : 'response-block'"
            [style.border-color]="' ' + highlightColor + ' '" [disabled]="disableResponseButtons"
            (click)="submitAnswer($index)">
            {{response}}
          </button>
          @if (silentTiles[$index]) {
            <button class="font-24" [class]="(disableResponseButtons) ? 'silent-e-grayed' : 'silent-e'"
              [style.border-color]="' ' + highlightColor + ' '"
              [disabled]="disableResponseButtons" (click)="submitAnswer($index)">
              e
            </button>
          }
          @if (!silentTiles[$index]) {
            <button class="silent-e-hidden" [style.border-color]="' ' + highlightColor + ' '"></button>
          }
        </div>
      }
    </div>
    <div class="response-row">
      <!-- use $index + 4 so we can keep the index returned unique because $index resets when we start a new ngFor -->
      @for (response of responseOptions2; track $index) {
        <div class="button-div">
          <button class="font-30" [class]="(disableResponseButtons) ? 'response-block-grayed' : 'response-block'"
            [style.border-color]="' ' + highlightColor + ' '" [disabled]="disableResponseButtons"
            (click)="submitAnswer($index+4)">
            {{response}}
          </button>
          @if (silentTiles[$index + 4]) {
            <button class="font-24" [class]="(disableResponseButtons) ? 'silent-e-grayed' : 'silent-e'"
              [style.border-color]="' ' + highlightColor + ' '"
              [disabled]="disableResponseButtons" (click)="submitAnswer($index+4)">
              e
            </button>
          }
          @if (!silentTiles[$index + 4]) {
            <button class="silent-e-hidden" [style.border-color]="' ' + highlightColor + ' '"></button>
          }
        </div>
      }
    </div>
  </div>
  <trial-counter [showCorrectIncorrect]="false" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTrialData()"></save-data-dialog>
</div>
